<template><div><h2 id="pointer-event-classes" tabindex="-1" class="d-docsite--header-2">Pointer Event Classes <a class="header-anchor d-link d-docsite--link d-link" href="#pointer-event-classes" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-pe-auto&quot;&gt;.d-pe-auto&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-pe-inherit&quot;&gt;.d-pe-inherit&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-pe-none&quot;&gt;.d-pe-none&lt;/div&gt;'>
<dt-stack data-demo-wrapper direction="row" gap="100">
  <div class="d-p-200 d-bgc-moderate d-code--sm d-pe-auto">.d-pe-auto</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-pe-inherit">.d-pe-inherit</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-pe-none">.d-pe-none</div>
</dt-stack>
</code-example>
<h2 id="user-select-classes" tabindex="-1" class="d-docsite--header-2">User Select Classes <a class="header-anchor d-link d-docsite--link d-link" href="#user-select-classes" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use the <code v-pre>user-select</code> property to control whether the user can select text.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-us-all&quot;&gt;
  &lt;dt-stack gap=&quot;100&quot; class=&quot;d-ta-center&quot;&gt;
    &lt;div&gt;.d-us-all&lt;/div&gt;
    &lt;div&gt;Try to select my text.&lt;/div&gt;
  &lt;/dt-stack&gt;
&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-us-auto&quot;&gt;
  &lt;dt-stack gap=&quot;100&quot; class=&quot;d-ta-center&quot;&gt;
    &lt;div&gt;.d-us-auto&lt;/div&gt;
    &lt;div&gt;Try to select my text.&lt;/div&gt;
  &lt;/dt-stack&gt;
&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-us-none&quot;&gt;
  &lt;dt-stack gap=&quot;100&quot; class=&quot;d-ta-center&quot;&gt;
    &lt;div&gt;.d-us-none&lt;/div&gt;
    &lt;div&gt;Try to select my text.&lt;/div&gt;
  &lt;/dt-stack&gt;
&lt;/div&gt;'>
<dt-stack data-demo-wrapper direction="row" gap="100">
  <div class="d-p-200 d-bgc-moderate d-code--sm d-us-all">
    <dt-stack gap="100" class="d-ta-center">
      <div>.d-us-all</div>
      <div>Try to select my text.</div>
    </dt-stack>
  </div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-us-auto">
    <dt-stack gap="100" class="d-ta-center">
      <div>.d-us-auto</div>
      <div>Try to select my text.</div>
    </dt-stack>
  </div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-us-none">
    <dt-stack gap="100" class="d-ta-center">
      <div>.d-us-none</div>
      <div>Try to select my text.</div>
    </dt-stack>
  </div>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{ class: className, output } in pointerEvents">
        <th scope="row" class="d-code--sm d-docsite-code">.{{ className }}</th>
        <td class="d-code--sm">{{ output }}</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { pointerEvents } from '@data/interactivity.json';
</script>